export default __webpack_public_path__ + "maps-examples-camera-animation-960-293ef9a630c43b98ff735052f7c5cc95.webp";